import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../../../fundamentals/text-styles/constants.js'
import { rowAlignmentMap, rowDefaultAlignment } from '../../constants.js'
import colorsOptions from '../../../../fundamentals/colors-styles/constants.js'

export const TableRowCellWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  min-height: 40px;

  align-content: ${({ orientation }) => orientation || 'left'};
  text-align: ${({ orientation }) => orientation || 'left'};
  justify-content: ${({ orientation }) =>
    rowAlignmentMap[orientation] || rowDefaultAlignment};
`

// Row text
export const RowTextContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

export const RowTextsColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const RowText = styled.span`
  ${({ weight }) =>
    textStyleWeightStyleOptions[weight] ??
    textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${({ size }) =>
    textStyleSizeStyleOptions[size] ??
    textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};

  color: ${({ color }) => color ?? colorsOptions.greys['grey-90']};

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
